'use client'

import { JSX } from 'react'

import { RefreshCwIcon } from 'lucide-react'

import { Button, EmptyState, PageLayout } from '~/components/component-library'

export function Custom404(): JSX.Element {
  return (
    <PageLayout>
      <EmptyState
        fullScreen
        headingLevel={1}
        size="page"
        title="404"
        className="mt-32"
      >
        <p>Page not found. Please try refreshing the page.</p>
        <div className="inline-block">
          <Button
            variant={'secondary'}
            onClick={() => window.location.reload()}
            suffix={<RefreshCwIcon />}
          >
            Refresh page
          </Button>
        </div>
      </EmptyState>
    </PageLayout>
  )
}
